import { Expand } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogPanel,
  DialogTitle,
} from "@/components/ui/dialog";

import { PnrDisplayTab } from "../../tabs/pnr-display-tab";

/**
 * « Afficher l'image du PNR » — opens the archived PNR_Display in a modal from the Réservation tab.
 * The popup is unmounted while closed, so the image is only fetched on demand.
 */
export function PnrDisplayDialog({ claimId }: { claimId: string }) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <Button variant="outline" onClick={() => setOpen(true)}>
        <Expand aria-hidden="true" />
        Afficher l'image du PNR
      </Button>
      <DialogContent className="max-h-[90vh] sm:max-w-4xl">
        <DialogHeader>
          <DialogTitle>Image du PNR</DialogTitle>
          {/* The dated « Dernière image » line is printed by the tab once the image is loaded. */}
          <DialogDescription className="sr-only">
            Dernière image de la réservation dans Amadeus
          </DialogDescription>
        </DialogHeader>
        <DialogPanel className="px-2 pb-2">
          <PnrDisplayTab claimId={claimId} />
        </DialogPanel>
      </DialogContent>
    </Dialog>
  );
}
